import React from 'react';
import {
  List, Datagrid, TextField, DateField, EditButton,
} from 'react-admin';

import { MetaFilter } from './components';

const MetaList = props => (
  <List filters={<MetaFilter />} {...props}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="route" />
      <TextField source="title" />
      <TextField source="description" />
      <DateField source="created_at" />
      <DateField source="updated_at" />
      <EditButton />
    </Datagrid>
  </List>
);

export default MetaList;
